import React from 'react';
import { motion } from 'framer-motion';
interface MentorSectionProps {
  checkoutUrl: string;
}
export const MentorSection = ({
  checkoutUrl
}: MentorSectionProps) => {
  return <section className="w-full py-8 sm:py-12 px-4 bg-white" data-id="element-189">
      <div className="container mx-auto max-w-5xl" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-8" data-id="element-191">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-192">
            Conoce a tu Mentor
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-193" />
        </motion.div>
        <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8 md:gap-10" data-id="element-194">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-2/5" data-id="element-195">
            <div className="relative rounded-2xl overflow-hidden border-4 border-[#7A3EFF] shadow-xl" data-id="element-196">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u55s5bk4VgrEGivw96oKJ9/DSC_3432.jpg" alt="DanyCredit" className="w-full h-auto object-cover" data-id="element-197" />
            </div>
            {/* Name under image */}
            <div className="mt-4 text-center" data-id="element-198">
              <div className="inline-block bg-[#7A3EFF] text-white px-6 py-3 rounded-xl" data-id="element-199">
                <p className="text-2xl font-bold tracking-wider" data-id="element-200">DANYCREDIT</p>
              </div>
            </div>
          </motion.div>
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-3/5" data-id="element-201">
            <div className="space-y-4 text-gray-700 leading-relaxed text-sm sm:text-base" data-id="element-202">
              <p data-id="element-203">
                Soy Daniel González, fundador de iFixCred. Mi misión comenzó
                cuando yo mismo tuve que aprender, con errores y sin guía, cómo
                funcionaba el sistema crediticio en Estados Unidos. Sé lo que es
                no tener respuestas, cometer fallas por desinformación y sentir
                que las oportunidades existen… pero no para ti.
              </p>
              <p data-id="element-204">
                Por eso decidí cambiar mi historia — y hoy también la de miles
                de hispanos en todo el país. Tras años de estudio y experiencia
                real, construí una empresa que supera $1,000,000 en facturación
                anual, ayudando a personas comunes a entender el crédito,
                acceder a capital y abrir puertas que antes parecían imposibles.
              </p>
              <p data-id="element-205">
                Mi propósito es claro: que nuestra comunidad hispana aprenda a
                usar el crédito como una herramienta para transformar su vida y
                su futuro.
              </p>
              <p className="font-semibold text-black" data-id="element-206">
                Estoy aquí para guiarte con estrategias reales y un compromiso
                genuino con tu crecimiento.
              </p>
            </div>
            {/* CTA - New Style */}
            <div className="mt-6 flex justify-center md:justify-start" data-id="element-207">
              <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-10 sm:px-14 py-4 bg-white text-[#7B2BFD] text-lg sm:text-xl font-bold rounded-full transition-all duration-300" style={{
              border: '3px solid #7B2BFD',
              boxShadow: '0 0 20px rgba(123, 43, 253, 0.4), 0 0 40px rgba(123, 43, 253, 0.2)'
            }} animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} whileHover={{
              scale: 1.08,
              boxShadow: '0 0 30px rgba(123, 43, 253, 0.6), 0 0 60px rgba(123, 43, 253, 0.4)'
            }} whileTap={{
              scale: 0.95
            }} data-id="element-208">
                RESERVAR MI CUPO
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};